
import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { columns, erpColumns, formateErpProducts } from './erpMapConst';

import './erpForm.less';

export default forwardRef((props, ref) => {
  const { currentMap = {} } = props;
  const { supplierId, mappingProducts = [], isRelation } = currentMap;
  const defaultValueMap = formateErpProducts(currentMap);

  const [form] = Form.useForm();
  form.setFieldsValue(defaultValueMap);

  const onFinish = (values) => {
    props.erpMapSubmit({ ...values, supplierId });
  };

  const onReset = () => {
    props.erpMapCancel({ supplierId });
  };

  useImperativeHandle(ref, () => ({ form }));

  return (
    <div className='erp-map-form'>
      <Form form={form} name="provider" onFinish={onFinish}>
        {
          !isRelation ? <Row>
            {erpColumns.map((item, index) => {
              return <Col key={item.name} span={index !== 1 ? 7 : 8} offset={index ? 1 : 0}>
                <Form.Item name={item.name} label={item.label} rules={[{ required: index !== 2, message: item.message }]}>
                  <Input />
                </Form.Item>
              </Col>;
            })}
          </Row>
            : null
        }
        {
          mappingProducts.length ? <table className='erp-map-table' >
            <thead><tr>
              {columns.map(item => <th key={item.key} colSpan={item.colSpan || 1} style={{ textAlign: item.align, width: item.width }}>{item.name}</th>)}
            </tr></thead>
            <tbody className='erp-map-table-body'>
              {
                mappingProducts.map(item => {
                  const { sale_id, cart_id } = item;
                  return (<tr key={cart_id}>
                    {
                      columns.map(subItem => {
                        const { key, align, width } = subItem;
                        if (key === 'sale_name' || key === 'sku_no') {
                          return <td style={{ textAlign: align, width: width }} key={`${key}_${sale_id}`}>{item[key]}</td>;
                        } else {
                          return <td style={{ textAlign: align, width: width }} key={`${key}_${sale_id}`}>
                            <Form.Item
                              name={`${key}_${sale_id}`}
                              rules={[{ required: true, message: subItem.name }]}
                            >
                              <Input />
                            </Form.Item>
                          </td>;
                        }
                      })
                    }
                  </tr>);
                })
              }
            </tbody>
          </table> : null
        }

        <Row>
          <Col offset={7} span={10} className='erp-map-form-btn-container'>
            <Form.Item><Button className='erp-map-form-btn erp-map-form-btn-cancel' onClick={onReset}>取消</Button></Form.Item>
            <Form.Item><Button className='erp-map-form-btn' type='primary' htmlType="submit">保存</Button></Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
});
